import axios from '@/libs/axios'

export const getOwners = (params) => {
  return new Promise((resolve, reject) => {
    axios.get(`userGetLinked?type=user`, { params: params })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export const getDrivers = (params) => {
  return new Promise((resolve, reject) => {
    axios.get(`userGetLinked?type=driver`, { params: params })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}
export const getSubstitute = (params) => {
  return new Promise((resolve, reject) => {
    axios.get(`userGetLinked?type=device`, { params: params })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export const getGroups = (params) => {
  return new Promise((resolve, reject) => {
    axios.get(`userGetLinked?type=group`, { params: params })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}


export const getContracts = (params) => {
  return new Promise((resolve, reject) => {
    axios.get(`userGetLinked?type=contract`, { params: params })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export const getDistricts = () => {
  return new Promise((resolve, reject) => {
    axios.get(`districts`)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}


export const getCategoriesBy = (params) =>  {
  return new Promise((resolve, reject) => {
    axios.get(`form/getCategoriesOptionsBy`, { params: params })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export const getTypesByCategory = (params) =>  {
  return new Promise((resolve, reject) => {
    axios.get(`form/getTypesOptionsBy`, { params: params })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })

  
}


export const getGeofenceGeneralTypes= () =>  {
  return new Promise((resolve, reject) => {
    axios.get(`types?model=geofence`)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })

  
}